/**
 * 后期处理 pipeline。按当前画质档位选择启用的 effect。
 * Phase 1 仅 Bloom + SSAO，Phase 6 视效果再加 DOF / TAA / GodRays。
 */
import { EffectComposer, Bloom, N8AO } from '@react-three/postprocessing'
import { useAppStore } from '@/core/store'
import { QUALITY_PROFILES } from '@/core/constants'

export function PostFX() {
  const tier = useAppStore((s) => s.settings.quality)
  const profile = QUALITY_PROFILES[tier]
  const { bloom, ssao } = profile.postFx

  // 全部关掉时不挂载 EffectComposer，避免无 effect pass 报错。
  if (!bloom && !ssao) return null

  return (
    <EffectComposer>
      {ssao ? <N8AO aoRadius={0.6} intensity={1.2} distanceFalloff={1.0} /> : <></>}
      {bloom ? <Bloom intensity={0.5} luminanceThreshold={0.7} mipmapBlur /> : <></>}
    </EffectComposer>
  )
}
